var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{staticClass:"m-auto mb-5",attrs:{"src":require("../assets/img/Check.png"),"alt":"Sukses","srcset":""}}),_c('h1',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }